/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box, CardMedia, useTheme } from "@mui/material";
import {
  getPaginationItemStyles,
  imageContainerStyles,
  imageStyles,
  slideStyles,
  sliderContainerStyles,
} from "./styles";

interface IProps {
  id: string;
  images: IProductImage[];
  title: string;
}

const Images: React.FC<IProps> = ({ title, images, id }) => {
  const INITIAL_SLIDE = 0;
  const swiperRef = useRef<any>(null);
  const [activeSlide, setActiveSlide] = useState(INITIAL_SLIDE); // Active slide state
  const theme = useTheme();

  // Goes to first slide on product change
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(INITIAL_SLIDE);
      setActiveSlide(INITIAL_SLIDE);
    }
  }, [id]);

  // Pagination Control
  const goToSlide = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(index);
      setActiveSlide(index);
    }
  };

  return (
    <Box
      sx={imageContainerStyles}
      display="flex"
      flexDirection={{ xs: "column", sm: "row-reverse" }}
      mb={{ xs: 3, md: 0 }}
      mx={{ xs: "auto", sm: 0 }}
    >
      {/* Main image slider */}
      <Box
        component={Swiper}
        ref={swiperRef}
        spaceBetween={2}
        slidesPerView={1}
        sx={sliderContainerStyles}
        onActiveIndexChange={(swiper) => {
          setActiveSlide(swiper.activeIndex);
        }}
      >
        {images.map(({ fullPath }, index) => (
          <SwiperSlide key={index}>
            <Box bgcolor="background.default" sx={slideStyles}>
              <CardMedia
                component="img"
                image={fullPath}
                alt={title}
                sx={imageStyles}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Box>

      {/* Pagination */}
      <Box
        display="flex"
        maxWidth="90vw"
        flexDirection={{ xs: "row", sm: "column" }}
        gap={{ xs: 0.5, lg: 3 }}
        mt={{ xs: 1.5, sm: 0 }}
        mr={{ xs: 0, sm: 2, md: 3, lg: 4.5 }}
        sx={{
          maxHeight: "74vh",
          width: "800px",
          boxSizing: "border-box",
          overflowY: "auto",
          overflowX: "scroll",
          border: "none",
          position: "relative",
          borderRadius: "20px",
          padding: { xs: 2, md: 4 },

          "&::-webkit-scrollbar": {
            width: "6px",
            backgroundColor: "#f5f5f5",
          },

          "&::-webkit-scrollbar-track": {
            background: "#fff",
          },

          "&::-webkit-scrollbar-thumb": {
            background: "lightgray",
            borderRadius: "20px",
          },

          "&::-webkit-scrollbar-thumb:hover": {
            background: "gray",
            cursor: "pointer",
          },
        }}
      >
        {images.map(({ fullPath }, index) => (
          <Box
            key={index}
            onClick={() => goToSlide(index)}
            sx={getPaginationItemStyles(theme, activeSlide === index)}
          >
            <CardMedia component="img" image={fullPath} sx={imageStyles} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Images;
